import React, { useEffect, useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography } from '@mui/material';
import { usePagosInmuebles } from '../../hooks/usePagosInmuebles';
import { IPagoInmuebleListItem } from '../../models/pagosInmuebles';
import { ListPagosInmuebles } from './ListPagosInmuebles';
import { DetalleCasaPago } from './DetalleCasaPago';
import { RegistrarPago } from './RegistrarPago';

type Vista = 'list' | 'detalle' | 'registrar';

export const PagosInmuebles = () => {
    const { getListado } = usePagosInmuebles();

    const [vista, setVista] = useState<Vista>('list');
    const [listado, setListado] = useState<IPagoInmuebleListItem[]>([]);
    const [loading, setLoading] = useState(true);
    const [casaSeleccionada, setCasaSeleccionada] = useState<IPagoInmuebleListItem | null>(null);
    const [mostrarCargaMasiva, setMostrarCargaMasiva] = useState(false);

    const cargarListado = async () => {
        setLoading(true);
        const data = await getListado();
        if (data) setListado(data);
        setLoading(false);
    };

    useEffect(() => {
        cargarListado();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleSelectCasa = (casa: IPagoInmuebleListItem) => {
        setCasaSeleccionada(casa);
        setVista('detalle');
    };

    const handleRegistrarPago = (casa: IPagoInmuebleListItem) => {
        setCasaSeleccionada(casa);
        setVista('registrar');
    };

    const handleVolver = () => {
        setVista('list');
        setCasaSeleccionada(null);
        cargarListado();
    };

    if (vista === 'detalle' && casaSeleccionada) {
        return (
            <DetalleCasaPago
                casaItem={casaSeleccionada}
                onBack={handleVolver}
                onRegistrarPago={() => setVista('registrar')}
            />
        );
    }

    if (vista === 'registrar' && casaSeleccionada) {
        return (
            <RegistrarPago
                casaItem={casaSeleccionada}
                onBack={() => setVista('detalle')}
                onGuardado={handleVolver}
            />
        );
    }

    return (
        <>
            <ListPagosInmuebles
                listado={listado}
                loading={loading}
                onSelectCasa={handleSelectCasa}
                onRegistrarPago={handleRegistrarPago}
                onCargarPagos={() => setMostrarCargaMasiva(true)}
            />

            <Dialog open={mostrarCargaMasiva} onClose={() => setMostrarCargaMasiva(false)} fullWidth maxWidth="xs">
                <DialogTitle>Cargar pagos</DialogTitle>
                <DialogContent>
                    <Typography variant="body2" color="text.secondary">
                        La carga masiva de pagos está en desarrollo — todavía falta definir el formato
                        del archivo a subir (Excel/CSV). El endpoint del backend ya está listo
                        (/api/PagosInmuebles/CargaMasiva) para recibir un lote de pagos una vez se
                        defina el parseo del archivo.
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setMostrarCargaMasiva(false)}>Cerrar</Button>
                </DialogActions>
            </Dialog>
        </>
    );
};
